/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Hall_Of_FameInputs */

const en_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame`)
};

const es_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de la fama`)
};

const de_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhmeshalle`)
};

const zh_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名人堂`)
};

const ar_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة المشاهير`)
};

const fr_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temple de la renommée`)
};

const vi_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại sảnh danh vọng`)
};

const sw_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi wa Umaarufu`)
};

const th_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หอเกียรติยศ`)
};

const bs_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuća slavnih`)
};

const ja_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`殿堂`)
};

const ko_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명예의 전당`)
};

const pt_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall da Fama`)
};

const it_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame`)
};

const sv_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ärans hall`)
};

const nl_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalerij`)
};

const da_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Æresgalleri`)
};

const nb_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Æresgalleri`)
};

const fi_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunniagalleria`)
};

const pl_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria sław`)
};

const ru_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зал славы`)
};

const tr_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şöhretler Müzesi`)
};

const hi_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ फेम`)
};

const id_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balai Kehormatan`)
};

const ms_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dewan Kemasyhuran`)
};

const cs_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síň slávy`)
};

const el_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πάνθεον Διασήμων`)
};

const he_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכל התהילה`)
};

const af_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalery`)
};

const hu_nav_hall_of_fame = /** @type {(inputs: Nav_Hall_Of_FameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hírességek Csarnoka`)
};

/**
* | output |
* | --- |
* | "Hall of Fame" |
*
* @param {Nav_Hall_Of_FameInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_hall_of_fame = /** @type {((inputs?: Nav_Hall_Of_FameInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Hall_Of_FameInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_hall_of_fame(inputs)
	if (locale === "de") return de_nav_hall_of_fame(inputs)
	if (locale === "zh") return zh_nav_hall_of_fame(inputs)
	if (locale === "ar") return ar_nav_hall_of_fame(inputs)
	if (locale === "fr") return fr_nav_hall_of_fame(inputs)
	if (locale === "vi") return vi_nav_hall_of_fame(inputs)
	if (locale === "sw") return sw_nav_hall_of_fame(inputs)
	if (locale === "th") return th_nav_hall_of_fame(inputs)
	if (locale === "bs") return bs_nav_hall_of_fame(inputs)
	if (locale === "ja") return ja_nav_hall_of_fame(inputs)
	if (locale === "ko") return ko_nav_hall_of_fame(inputs)
	if (locale === "pt") return pt_nav_hall_of_fame(inputs)
	if (locale === "it") return it_nav_hall_of_fame(inputs)
	if (locale === "sv") return sv_nav_hall_of_fame(inputs)
	if (locale === "nl") return nl_nav_hall_of_fame(inputs)
	if (locale === "da") return da_nav_hall_of_fame(inputs)
	if (locale === "nb") return nb_nav_hall_of_fame(inputs)
	if (locale === "fi") return fi_nav_hall_of_fame(inputs)
	if (locale === "pl") return pl_nav_hall_of_fame(inputs)
	if (locale === "ru") return ru_nav_hall_of_fame(inputs)
	if (locale === "tr") return tr_nav_hall_of_fame(inputs)
	if (locale === "hi") return hi_nav_hall_of_fame(inputs)
	if (locale === "id") return id_nav_hall_of_fame(inputs)
	if (locale === "ms") return ms_nav_hall_of_fame(inputs)
	if (locale === "cs") return cs_nav_hall_of_fame(inputs)
	if (locale === "el") return el_nav_hall_of_fame(inputs)
	if (locale === "he") return he_nav_hall_of_fame(inputs)
	if (locale === "af") return af_nav_hall_of_fame(inputs)
	if (locale === "hu") return hu_nav_hall_of_fame(inputs)
	return en_nav_hall_of_fame(inputs)
});